import React from "react";
import { useI18n } from "@/contexts/I18nContext";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback
          onRetry={() => this.setState({ hasError: false, error: null })}
          onHome={() => { window.location.href = "/"; }}
        />
      );
    }
    return this.props.children;
  }
}

function ErrorFallback({ onRetry, onHome }) {
  const { t } = useI18n();
  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-[#F7F8FA]">
      <div className="rp-card p-8 max-w-md w-full text-center space-y-4">
        <div className="text-xl font-bold text-gray-900">{t("error")}</div>
        <p className="text-sm text-gray-500">{t("loadError")}</p>
        <div className="flex gap-2 justify-center flex-wrap">
          <button type="button" onClick={onRetry} className="px-4 py-2 rounded-xl bg-[#071A33] text-white text-sm font-medium">
            {t("retry")}
          </button>
          <button type="button" onClick={onHome} className="px-4 py-2 rounded-xl border border-gray-200 text-sm font-medium">
            {t("dashboard")}
          </button>
        </div>
      </div>
    </div>
  );
}
